import React from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

export default function CampaignSchedule({ campaignSchedulePermission }) {
  const campaignData = useSelector((state) => state.campaignSetter);
  const userData = useSelector((state) => state.userSetter);


  const showToast = (info) => {
    toast.info(info);
  };

  const isComplianceCompany = () => {
    return userData.companyLevelComplaiceFlag;
  }
  const isComplianceApproved = () => {
    return campaignData.complaiceStatus === 'Approved' ? true : false;
  }
  const isCampaignTemplateExist = () => {
    return (campaignData.campaignTemplateId !== '' ||
      campaignData.campignTemplateId === null) ? true : false;
  }
  const isABTestCampaign = () => {
    return campaignData.campaignABTestEnabled
  }

  const isAllowedtoSchedule = () => {
    if (isABTestCampaign) {
      if (campaignData.campaingABTestData.campaignABTestVariation === 'Content') {
        return ((campaignData.campignTemplateId !== null) && (campaignData.campaingABTestData.campaignABTestTemplateId !== null)) ? true : false;
      } else {
        return (campaignData.campignTemplateId !== null) ? true : false;
      }
    } else {
      return (campaignData.campignTemplateId !== null) ? true : false;
    }
  }
  return (
    <div className='row justify-content-between align-items-end pt_15'>
      <div className='left_sec'>
        <div className='max534'>
          <label>Schedule</label>
          <p className='campaign_text'>Run now or schedule your campaign</p>
        </div>
      </div>
      <div className='right_sec'>
        {isComplianceCompany() === true ? (
          !(isComplianceApproved() === true) ? (
            !(isCampaignTemplateExist() === true) ? (
              <>
                <a
                  to=''
                  className='lg_btn primary'
                  onClick={() => campaignSchedulePermission && showToast('Please Create Design First')}
                  style={campaignSchedulePermission ? { opacity: 1 } : { cursor: 'not-allowed', opacity: 0.5 }}

                >
                  Schedule
                </a>
              </>
            ) : (
              <a
                to=''
                className='lg_btn primary'
                onClick={() => campaignSchedulePermission && showToast('Your campaign is not yet approved')}
                style={campaignSchedulePermission ? { opacity: 1 } : { cursor: 'not-allowed', opacity: 0.5 }}

              >
                Schedule
              </a>
            )
          ) : (
            <a
              to=''
              className='lg_btn primary'
              data-toggle={campaignSchedulePermission && 'modal'}
              data-target={
                campaignData.campaignABTestEnabled &&
                  campaignData.campaignABTestChecked
                  ? `#scheduleABTest`
                  : `#schedule`
              }
              style={campaignSchedulePermission ? { opacity: 1 } : { cursor: 'not-allowed', opacity: 0.5 }}

            >
              Schedule
            </a>
          )
        ) : isAllowedtoSchedule() === true ?
          (
            <a
              to=''
              className='lg_btn primary'
              data-toggle={campaignSchedulePermission && 'modal'}
              data-target={
                campaignData.campaignABTestEnabled &&
                  campaignData.campaignABTestChecked
                  ? `#scheduleABTest`
                  : `#schedule`
              }
              style={campaignSchedulePermission ? { opacity: 1 } : { cursor: 'not-allowed', opacity: 0.5 }}
            >
              Schedule
            </a>
          ) : (
            <>
              <a
                to=''
                className='lg_btn primary'
                onClick={() => campaignSchedulePermission && showToast('Please Create Design First')}
                style={campaignSchedulePermission ? { opacity: 1 } : { cursor: 'not-allowed', opacity: 0.5 }}

              >
                Schedule
              </a>
            </>
          )}
      </div>
    </div>
  );
}
